$(document).ready(function () {
  $(".humberger-menu a").click(function (e) {
    e.preventDefault(); 
    $(".humber-menu-list").slideToggle(200);
    $(this).toggleClass("active");
  });
  // Find Car Button Click
  $(".find-car-btn-mobile").click(function (e) {
    e.preventDefault();
    $(".find-car-section-wrapper-mobile").slideDown(300); 
    $(".humber-menu-list").hide();
    $(".humberger-menu a").removeClass("active");
  });

  // Close Button Click
  $(".close-icon-mobile").click(function () {
    $(".find-car-section-wrapper-mobile").slideUp(300); // hide section
  });
  // Mobile Menu
  $(".menu_icon").click(function () {
    $(".menu").slideToggle(200);

    return false;
  });

  // Mobile Menu Icon
  $(document).ready(function () {
    $("#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4").click(function () {
      $(this).toggleClass("open");
    });
  });

  // Feature Carousel
  $(".ie_feature_slider_contents").owlCarousel({
    loop: true,
    nav: true,
    dots: true,
    autoplay: false,
    margin: 20,
    responsive: {
      0: {
        items: 1.1,
      },
      480: {
        items: 1.3,
      },
      768: {
        items: 1.3,
      },
      992: {
        items: 1.7,
      },
      1200: {
        items: 1.9,
      },
      1400: {
        items: 2.2,
      },
    },
  });
  $(".ie_feature_slider_contents .owl-prev").html('<i class="fa-solid fa-caret-left"></i>');
  $(".ie_feature_slider_contents .owl-next").html('<i class="fa-solid fa-caret-right"></i>');
  // Feature Carousel
  $(".ie_feature_slider_contents2").owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    autoplay: false,
    margin: 30,
    responsive: {
      0: {
        items: 1.4,
        nav: false,
      },
      700: {
        items: 1.5,
        nav: false,
      },
      1400: {
        nav: false,
        items: 1.6,
        margin: 56,
      },
    },
  });

  $(".your_next_model_card_main").owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    autoplay: false,
    margin: 24,
    responsive: {
      0: {
        items: 1.4,
      },
      900: {
        items: 2.4,
      },
      1400: {
        items: 3,
        margin: 60,
      },
    },
  });

  // Testimonials Carousel
  $(".ie_testimonials").owlCarousel({
    loop: true,
    autoplay: false,
    margin: 20,
    responsive: {
      0: {
        items: 1.1,
        nav: true,
        dots: true,
      },
      480: {
        items: 1.5,
      },
      768: {
        items: 2.1,
      },
      992: {
        items: 2.8,
      },
      1200: {
        items: 3.5,
        nav: false,
        dots: false,
      },
      1400: {
        items: 4,
      },
    },
  });
  $(".ie_testimonials .owl-prev").html('<i class="fa-solid fa-caret-left"></i>');
  $(".ie_testimonials .owl-next").html('<i class="fa-solid fa-caret-right"></i>');
});

document.addEventListener("DOMContentLoaded", () => {
  // Hero section Video popup start
  const watchBtn = document.getElementById("watchBtn");
  const pauseBtn = document.getElementById("pauseBtn");
  const fullscreenBtn = document.getElementById("fullscreenBtn");
  const closeBtn = document.getElementById("closeBtn");
  const heroVideo = document.getElementById("heroVideo");
  const heroYouTube = document.getElementById("heroYouTube");
  const overlay = document.getElementById("overlay");
  const content = document.getElementById("content");
  const videoControls = document.getElementById("videoControls");

  const heroSection = document.querySelector(".hero-section");
  const isYouTube = heroSection && heroSection.dataset.heroType === "youtube";

  let isExpanded = false;
  let isPaused = true;
  let ytPlayer = null;

  /* ── YouTube setup ── */
  if (isYouTube && heroYouTube) {
    var ytId = heroYouTube.dataset.youtubeId;

    // Load the YouTube IFrame API if not already present
    if (!window.YT) {
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(tag);
    }

    function createYTPlayer() {
      ytPlayer = new YT.Player("heroYouTube", {
        videoId: ytId,
        playerVars: {
          autoplay: 0,
          controls: 0,
          modestbranding: 1,
          rel: 0,
          showinfo: 0,
          playsinline: 1,
          enablejsapi: 1,
          origin: window.location.origin
        },
        events: {
          onReady: function(e) {
            ytPlayer.mute();
            var iframe = e.target.getIframe();
            if (iframe) {
              iframe.setAttribute("allow", "autoplay; fullscreen");
              iframe.setAttribute("allowfullscreen", "");
            }
          }
        }
      });
    }

    if (window.YT && window.YT.Player) {
      createYTPlayer();
    } else {
      window.onYouTubeIframeAPIReady = createYTPlayer;
    }
  }

  /* ── Native video setup ── */
  if (!isYouTube && heroVideo) {
    if (heroVideo.hasAttribute("autoplay")) heroVideo.removeAttribute("autoplay");
    heroVideo.pause();
    heroVideo.muted = true;
    heroVideo.currentTime = 0;
  }

  const PAUSE_SVG = `<svg fill="#000" viewBox="0 0 24 24"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/></svg>`;
  const PLAY_SVG  = `<svg fill="#000" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>`;

  // --- WATCH BUTTON ---
  if (watchBtn) watchBtn.addEventListener("click", async () => {
    isExpanded = true;
    overlay.classList.add("hidden");
    content.classList.add("hidden");
    videoControls.classList.add("visible");

    if (isYouTube && ytPlayer) {
      heroYouTube.classList.add("expanded");
      ytPlayer.unMute();
      ytPlayer.playVideo();
      isPaused = false;
      pauseBtn.innerHTML = PAUSE_SVG;
      pauseBtn.title = "Pause";
    } else if (heroVideo) {
      heroVideo.classList.add("expanded");
      heroVideo.muted = false;
      try {
        await heroVideo.play();
        isPaused = false;
        pauseBtn.innerHTML = PAUSE_SVG;
        pauseBtn.title = "Pause";
      } catch (err) {
        heroVideo.muted = true;
        try { await heroVideo.play(); } catch (_) {}
      }
    }
  });

  // --- PAUSE BUTTON ---
  if (pauseBtn) pauseBtn.addEventListener("click", () => {
    if (isYouTube && ytPlayer) {
      if (isPaused) {
        ytPlayer.playVideo();
        pauseBtn.innerHTML = PAUSE_SVG;
        pauseBtn.title = "Pause";
      } else {
        ytPlayer.pauseVideo();
        pauseBtn.innerHTML = PLAY_SVG;
        pauseBtn.title = "Play";
      }
    } else if (heroVideo) {
      if (isPaused) {
        heroVideo.play();
        pauseBtn.innerHTML = PAUSE_SVG;
        pauseBtn.title = "Pause";
      } else {
        heroVideo.pause();
        pauseBtn.innerHTML = PLAY_SVG;
        pauseBtn.title = "Play";
      }
    }
    isPaused = !isPaused;
  });

  // --- CLOSE BUTTON ---
  if (closeBtn) closeBtn.addEventListener("click", () => {
    isExpanded = false;
    isPaused = true;

    overlay.classList.remove("hidden");
    content.classList.remove("hidden");
    videoControls.classList.remove("visible");

    if (isYouTube && ytPlayer) {
      heroYouTube.classList.remove("expanded");
      ytPlayer.pauseVideo();
      ytPlayer.seekTo(0);
      ytPlayer.mute();
    } else if (heroVideo) {
      heroVideo.classList.remove("expanded");
      heroVideo.pause();
      heroVideo.currentTime = 0;
      heroVideo.load();
      heroVideo.muted = true;
    }

    pauseBtn.innerHTML = PLAY_SVG;
    pauseBtn.title = "Play";
  });

  // --- FULLSCREEN BUTTON ---
  if (fullscreenBtn) fullscreenBtn.addEventListener("click", () => {
    // For YouTube, fullscreen the hero section container (cross-origin iframes
    // block requestFullscreen on the iframe itself). For native video, use the
    // video element directly so browser native controls appear.
    var target = isYouTube ? heroSection : heroVideo;
    if (!target) return;

    var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
    if (fsEl) {
      (document.exitFullscreen || document.webkitExitFullscreen).call(document);
    } else if (target.requestFullscreen) {
      target.requestFullscreen();
    } else if (target.webkitRequestFullscreen) {
      target.webkitRequestFullscreen();
    } else if (target.webkitEnterFullscreen) {
      target.webkitEnterFullscreen();
    }
  });

  // --- PROGRESS / SCRUB BAR ---
  var progressBar = document.getElementById("videoProgress");
  var scrubBar = document.getElementById("videoScrubBar");
  var scrubFill = document.getElementById("videoScrubFill");
  var scrubHandle = document.getElementById("videoScrubHandle");
  var timeElapsed = document.getElementById("videoTimeElapsed");
  var timeDuration = document.getElementById("videoTimeDuration");
  var progressRAF = null;
  var isScrubbing = false;

  function fmtTime(s) {
    s = Math.floor(s || 0);
    var m = Math.floor(s / 60);
    var sec = s % 60;
    return m + ":" + (sec < 10 ? "0" : "") + sec;
  }

  function setProgress(pct) {
    scrubFill.style.width = pct + "%";
    scrubHandle.style.left = pct + "%";
  }

  function tickProgress() {
    if (isScrubbing) { progressRAF = requestAnimationFrame(tickProgress); return; }

    var cur = 0, dur = 0;
    if (isYouTube && ytPlayer && typeof ytPlayer.getCurrentTime === "function") {
      cur = ytPlayer.getCurrentTime();
      dur = ytPlayer.getDuration();
    } else if (heroVideo) {
      cur = heroVideo.currentTime;
      dur = heroVideo.duration || 0;
    }

    if (dur > 0) {
      setProgress((cur / dur) * 100);
      timeElapsed.textContent = fmtTime(cur);
      timeDuration.textContent = fmtTime(dur);
    }
    progressRAF = requestAnimationFrame(tickProgress);
  }

  function seekToFraction(frac) {
    frac = Math.max(0, Math.min(1, frac));
    if (isYouTube && ytPlayer && typeof ytPlayer.getDuration === "function") {
      ytPlayer.seekTo(frac * ytPlayer.getDuration(), true);
    } else if (heroVideo && heroVideo.duration) {
      heroVideo.currentTime = frac * heroVideo.duration;
    }
    setProgress(frac * 100);
  }

  function scrubFromEvent(e) {
    var rect = scrubBar.getBoundingClientRect();
    var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    return x / rect.width;
  }

  if (scrubBar) {
    scrubBar.addEventListener("mousedown", function(e) {
      isScrubbing = true;
      seekToFraction(scrubFromEvent(e));
    });
    scrubBar.addEventListener("touchstart", function(e) {
      isScrubbing = true;
      seekToFraction(scrubFromEvent(e));
    }, { passive: true });

    document.addEventListener("mousemove", function(e) {
      if (!isScrubbing) return;
      seekToFraction(scrubFromEvent(e));
    });
    document.addEventListener("touchmove", function(e) {
      if (!isScrubbing) return;
      seekToFraction(scrubFromEvent(e));
    }, { passive: true });

    document.addEventListener("mouseup", function() { isScrubbing = false; });
    document.addEventListener("touchend", function() { isScrubbing = false; });
  }

  // Show progress bar when video is playing, hide on close
  var origWatch = watchBtn && watchBtn.onclick;
  if (watchBtn) {
    var origWatchListeners = watchBtn.cloneNode(false);
    watchBtn.addEventListener("click", function() {
      if (progressBar) progressBar.classList.add("visible");
      if (!progressRAF) tickProgress();
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener("click", function() {
      if (progressBar) progressBar.classList.remove("visible");
      if (progressRAF) { cancelAnimationFrame(progressRAF); progressRAF = null; }
      setProgress(0);
      timeElapsed.textContent = "0:00";
    });
  }
});
// Hero section Video popup end
// Section start video
document.addEventListener("DOMContentLoaded", function () {
  // Use a slight delay to ensure all videos are loaded
  setTimeout(() => {
    const yearItems = document.querySelectorAll(".year-item");

    yearItems.forEach((item) => {
      const video = item.querySelector(".video-background");
      const videoControl = item.querySelector(".video-control");

      // Check if video and controls exist
      if (!video || !videoControl) return;

      // Try to play the video
      video.play().catch((err) => {
        console.log("Autoplay prevented:", err);
      });

      videoControl.classList.add("playing");

      videoControl.addEventListener("click", (e) => {
        e.stopPropagation();
        if (video.paused) {
          video.play();
          videoControl.classList.add("playing");
        } else {
          video.pause();
          videoControl.classList.remove("playing");
        }
      });

      video.addEventListener("play", () => {
        videoControl.classList.add("playing");
      });

      video.addEventListener("pause", () => {
        videoControl.classList.remove("playing");
      });
    });
  }, 100); // Small delay to ensure DOM is fully rendered
});
// Section End video
// Scroll to top button start
const scrollButtons = document.getElementById("scrollButtons");
const returnTopBtn = document.getElementById("returnTop");
const scrollThreshold = 200;

// Show/hide buttons on scroll
window.addEventListener("scroll", () => {
  if (window.scrollY > scrollThreshold) {
    scrollButtons.classList.add("visible");
  } else {
    scrollButtons.classList.remove("visible");
  }
});

// Smooth scroll to top
returnTopBtn.addEventListener("click", (e) => {
  e.preventDefault();
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
});
// Scroll to top button end
// Wait for DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Get elements
  const findCarBtn = document.querySelector(".find-car-btn a");
  const closeBtn = document.querySelector(".close-btn"); // You may need to add a class to your close button
  const menuBottom = document.querySelector(".menu-bottom-items");
  const findCarSection = document.querySelector(".find-car-section-wrapper"); // The section with "FIND YOUR CAR" and dropdowns

  // Add click event to "SHOP YOUR CAR" button
  if (findCarBtn) {
    findCarBtn.addEventListener("click", function (e) {
      e.preventDefault();

      // Hide menu
      if (menuBottom) {
        menuBottom.style.display = "none";
      }

      // Show find car section
      if (findCarSection) {
        findCarSection.style.display = "block";
      }
    });
  }

  // Add click event to close button
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();

      // Show menu
      if (menuBottom) {
        menuBottom.style.display = "block";
      }

      // Hide find car section
      if (findCarSection) {
        findCarSection.style.display = "none";
      }
    });
  }
});

const scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: ".scroll-spy",
  offset: 100,
});

// Scrollspy menu to section start
(function () {
  const offset = 110; // Your header height
  const navLinks = document.querySelectorAll(".nav-link");
  const sections = Array.from(navLinks)
    .map((link) => {
      const href = link.getAttribute("href");
      return href ? document.querySelector(href) : null;
    })
    .filter(Boolean);

  function setActiveLink() {
    const scrollPos = window.scrollY + offset + 1;
    let currentSection = null;

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;
      if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
        currentSection = section;
      }
    });

    // Remove active from all
    navLinks.forEach((link) => link.classList.remove("active"));

    if (currentSection) {
      // সব nav-link যেগুলোর href একই সেগুলোর উপর active যোগ করা
      const activeLinks = document.querySelectorAll(`.nav-link[href="#${currentSection.id}"]`);
      activeLinks.forEach((link) => link.classList.add("active"));
    }
  }

  // smooth scroll
  navLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href");
      const targetSection = document.querySelector(targetId);
      if (targetSection) {
        const targetPosition = targetSection.offsetTop - offset;
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  });

  let ticking = false;
  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        setActiveLink();
        ticking = false;
      });
      ticking = true;
    }
  });

  setActiveLink();
})();


// Scrollspy menu to section End
